import { ChakraProvider, ColorModeScript, CSSReset } from "@chakra-ui/react";
import * as React from "react";
import ReactDOM from "react-dom";
import { QueryClientProvider } from "react-query";
// * Configs and Base component
import { theme } from "./components/styles/theme";
import { queryClient } from "./helpers/configs/libs/react-query";
import Plugins from "./helpers/configs/plugins";
import Routes from "./Routes";
// * Style and language
import "react-widgets/styles.css";
import "./components/styles/global.css";
import "./helpers/languages/i18n";

ReactDOM.render(
  <React.StrictMode>
    <CSSReset />
    <ChakraProvider theme={theme}>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <QueryClientProvider client={queryClient}>
        <Plugins>
          <Routes />
        </Plugins>
      </QueryClientProvider>
    </ChakraProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);
